module.exports = __webpack_public_path__ + "static/media/CA32.2f6d0c6f.jpg";